import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/styles';

import { translate } from '../../../i18n/I18nProvider';
import styles, { customStyles } from '../styles/numbers';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import { InputAdornment, RadioGroup, TextField } from '@material-ui/core';
import CustomFormControlLabel from '../../../partials/customFormControlLabel';
import SecondaryButton from '../../../partials/customButtons/SecondaryButton';
import { Search } from '@material-ui/icons';
import clsx from 'clsx';
import { doesArrayHasLength, isDefined } from '../../../utils/isDefined';
import { getData } from '../../../utils/http';
import { URLS } from '../../../consts/endpoints';
import mapNumberToDisplay from '../../../utils/mapNumberToDisplay';
import { buildSearchFilter } from '../actions/filteringActions';

const PAGE_SIZE = 20;

const NewNumbers = ({ classes, values, setFieldValue }) => {
  const [search, setSearch] = useState('');
  const [availableNumbers, setAvailableNumbers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(0);

  const fetchAvailableNumbers = async (page = 0, searchValue = search) => {
    setLoading(true);
    try {
      const filter = buildSearchFilter(searchValue);
      const params = { 'page[size]': PAGE_SIZE, 'page[number]': page };
      if (filter) {
        params.phone_number = filter;
      }
      const response = await getData({
        options: {
          url: `${URLS.QUOTE_PHONE_NUMBERS}/available`,
          params
        }
      });

      const totalCount = parseInt(
        response?.headers?.['x-total_count'] ||
          response?.headers?.['x-total-count'] ||
          0,
        10
      );

      if (totalCount > 0) {
        setTotalPages(Math.ceil(totalCount / PAGE_SIZE));
      }

      const data = response?.data ?? response;
      if (doesArrayHasLength(data)) {
        setAvailableNumbers(data);
      } else {
        setAvailableNumbers([]);
      }
    } catch (error) {
      console.error('Error fetching available numbers:', error);
      setAvailableNumbers([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAvailableNumbers(0);
    // eslint-disable-next-line
  }, []);

  const handleSearchChange = e => {
    const value = e.target.value;
    setSearch(value);
    const filter = buildSearchFilter(value);
    if (filter || value === '') {
      setCurrentPage(0);
      fetchAvailableNumbers(0, value);
    }
  };

  const handleClearSearch = () => {
    setSearch('');
    setCurrentPage(0);
    fetchAvailableNumbers(0, '');
  };

  const handleReload = () => {
    let randomPage = 0;
    if (totalPages > 1) {
      do {
        randomPage = Math.floor(Math.random() * totalPages);
      } while (randomPage === currentPage);
    }
    setCurrentPage(randomPage);
    fetchAvailableNumbers(randomPage, search);
  };

  return (
    <div className={classes.root}>
      {translate('REQUEST_NEW_USER.NUMBERS_INFO')}

      <div className={classes.searchRow}>
        <TextField
          variant="outlined"
          margin="dense"
          onChange={handleSearchChange}
          value={search}
          style={{ ...customStyles.textfieldRoot, maxWidth: '300px' }}
          className={classes.searchField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {isDefined(search) && search.length > 0 && (
                  <i
                    className={clsx('fas fa-times', classes.closeIcon)}
                    onClick={handleClearSearch}
                  ></i>
                )}
              </InputAdornment>
            )
          }}
          inputProps={{ autoComplete: 'off', 'data-lpignore': true }}
        />
        <div className={classes.reloadButton}>
          <SecondaryButton onClick={handleReload} disabled={loading}>
            {translate('REQUEST_NEW_USER.SHOW_DIFFERENT_NUMBERS')}
          </SecondaryButton>
        </div>
      </div>
      <div className={classes.numbersContainer}>
        <RadioGroup
          className={classes.radioButtons}
          value={values.mobile_number}
          onChange={e => setFieldValue('mobile_number', e.target.value)}
        >
          {loading && (
            <div className={classes.noNumbers}>{translate('LOADING')}...</div>
          )}
          {!loading && availableNumbers.length === 0 && (
            <div className={classes.noNumbers}>
              {translate('REQUEST_NEW_USER.NO_NUMBERS')}
            </div>
          )}
          {!loading &&
            availableNumbers.map(num => {
              return (
                <CustomFormControlLabel
                  key={num.number}
                  value={num.number}
                  label={mapNumberToDisplay(num.number)}
                />
              );
            })}
        </RadioGroup>
      </div>
    </div>
  );
};

const mapStatesToProps = ({ requestUserWizard }) => {
  return {
    availableNumbers: requestUserWizard.selectOptions.availableNumbersOptions
  };
};

export default flowRight(connect(mapStatesToProps))(
  withStyles(styles)(NewNumbers)
);
